/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateAdditionalInsuredDto = {
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string;
    /**
     * First name
     */
    firstName: string;
    /**
     * Last name
     */
    lastName: string;
    /**
     * Date of birth
     */
    dob: string;
    /**
     * Gender
     */
    gender: CreateAdditionalInsuredDto.gender;
    /**
     * Preferred name
     */
    preferredName?: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Preferred phone type
     */
    preferredPhone?: CreateAdditionalInsuredDto.preferredPhone;
    /**
     * Mobile phone number
     */
    mobile?: string;
    /**
     * Home phone number
     */
    homePhone?: string;
    /**
     * Work phone number
     */
    workPhone?: string;
    /**
     * Relationship to the client
     */
    relationship?: CreateAdditionalInsuredDto.relationship;
};
export namespace CreateAdditionalInsuredDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Preferred phone type
     */
    export enum preferredPhone {
        MOBILE = 'MOBILE',
        HOME = 'HOME',
        WORK = 'WORK',
    }
    /**
     * Relationship to the client
     */
    export enum relationship {
        PARTNER_SPOUSE = 'PARTNER_SPOUSE',
        PARENT = 'PARENT',
        CHILD = 'CHILD',
        FRIEND = 'FRIEND',
        OTHER = 'OTHER',
        POLICY_OWNER = 'POLICY_OWNER',
        BUSINESS_PARTNER = 'BUSINESS_PARTNER',
        SIBLING = 'SIBLING',
    }
}

